module.exports = __webpack_public_path__ + "static/media/ic-close.88d74035.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/ic-close.svg
// module id = 104
// module chunks = 0